module.exports = __webpack_public_path__ + "static/media/our-vision-first@3x.640d6f91.jpg";